(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-review-shortcut"] && !Shopify.designMode) return;
  try {
    const positionReviewShortcut = () => {
    const addToCartButton = document.getElementById('AddToCart');
    const reviewShortcut = document.querySelector('.product-review-shortcut');

    if (addToCartButton && reviewShortcut && addToCartButton.nextElementSibling !== reviewShortcut) {
      addToCartButton.insertAdjacentElement('afterend', reviewShortcut);
    }
  };

  const initializeReviewShortcut = () => {
    positionReviewShortcut();

    const paymentButtons = document.querySelector('.paymentButtonsWrapper');

    if (paymentButtons) {
      const observer = new MutationObserver(positionReviewShortcut);
      observer.observe(paymentButtons, { childList: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeReviewShortcut);
  } else {
    initializeReviewShortcut();
  }
  } catch(e) { console.error(e); }
})();

})();
